/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Guest { 
    readonly id: number;
    name: string;
    surname: string;
    fullName: string;
    email: string;
    phone?: string;
    staff: boolean;
    legacyId?: string;
    resourcePermissions?: Array<string>;
}

